import React from "react";
import { Alert } from "react-native";

import { useViewport } from "@/contexts/ViewportContext";
import { useAppNavigation } from "@/hooks/application/navigation";
import { useAppDispatch } from "@/hooks/application/store";
import { useSignupCustomer } from "@/hooks/domain/signup";
import { AuthNavigation } from "@/navigation/stacks/AuthenticationStack";
import analytics from "@/services/analytics";
import { logger } from "@/services/logger";
import { registerForPushNotificationsAsync } from "@/services/notification";
import { LOGIN } from "@/store/ducks/auth";
import { isNativeDevice } from "@/utils/platform";

import SignUpCustomerMobile from "./SignUpCustomer.mobile";
import SignUpCustomerWeb from "./SignUpCustomer.web";
import { CustomerFormData } from "./schema";

const SignUpCustomer = () => {
  const { isWebMode } = useViewport();

  const { goBack } = useAppNavigation<AuthNavigation>();
  const dispatch = useAppDispatch();

  const { mutate, isLoading } = useSignupCustomer({
    onSuccess: (data) => {
      dispatch(LOGIN(data.usuario));
    },
    onError: (error) => {
      logger.error(error);
      Alert.alert("Não conseguimos criar a sua conta", "Tente novamente mais tarde");
    },
  });

  const onSubmit = async (data: CustomerFormData) => {
    let notificationToken = undefined;
    if (isNativeDevice) {
      notificationToken = await registerForPushNotificationsAsync();
    }
    analytics.logEvent("lead", {
      name: data.nome,
      birthdate: data.dataNascimento,
      phone: data.telefone,
      type: "B2C",
    });
    if (data.dataNascimento) {
      const [day, month, year] = data.dataNascimento.split("/");
      data.dataNascimento = new Date(Number(year), Number(month) - 1, Number(day)).toISOString();
    }
    mutate({
      email: data.email.trim(),
      nome: data.nome,
      senha: data.senha.trim(),
      telefone: data.telefone,
      dataNascimento: data.dataNascimento,
      tokenExpo: notificationToken,
    });
  };

  const onCancel = () => goBack();

  const Screen = isWebMode ? SignUpCustomerWeb : SignUpCustomerMobile;

  return <Screen isSubmiting={isLoading} onCancel={onCancel} onSubmit={onSubmit} />;
};

export default SignUpCustomer;
